import { createTheme } from '@mui/material/styles'

// ── Brand core ────────────────────────────────────────────────────────────────
export const COLOR_PRIMARY = '#F4B632'  // Gold
export const COLOR_PRIMARY_HOVER = '#E5A820'   // Gold hover
export const COLOR_PRIMARY_HOVER1 = `${COLOR_PRIMARY}25`
export const COLOR_PRIMARY_HOVER2 = `${COLOR_PRIMARY}66`

export const NAVBAR_BG = '#0D1B2A'  // Darkest - navbar & footer bg
export const COLOR_SKY = '#4A90E2'  // Hover / accent
export const COLOR_GREEN = '#008000'
export const COLOR_RED = '#DC143C'

// ── Minitag score gradient (0–100 percentage) - internal constants used
//    by `minitagColor` only.
const MINITAG_NONE = '#B4B4B4'
const MINITAG_80 = '#2E8B57'
const MINITAG_60 = '#68AC86'
const MINITAG_40 = '#FF8C00'
const MINITAG_20 = '#DC5B74'
const MINITAG_0 = '#DC143C'

export function minitagColor(pct: number | undefined): string {
    if (!pct || pct === 0) return MINITAG_NONE
    if (pct > 80) return MINITAG_80
    if (pct > 60) return MINITAG_60
    if (pct > 40) return MINITAG_40
    if (pct > 20) return MINITAG_20
    return MINITAG_0
}

export const BORDER_BLACK = '1px solid black'
export const BORDER_BLUE = '1px solid blue'
export const BORDER_DIVIDER = '2px solid rgba(0, 0, 0, 0.12)'

// ── Font sizes ────────────────────────────────────────────────────────────────
export const FS_MICRO = '0.65rem'  // chip labels, group headers
export const FS_XS = '0.70rem'  // captions, timestamps, labels
export const FS_SM = '0.80rem'  // standard compact UI text
export const FS_MD = '0.90rem'  // body text in panels
export const FS_LG = '1rem'  // larger content text
export const FS_XL = '1.1rem' // medium icons and inline elements

// ── Icon sizes (px) ───────────────────────────────────────────────────────────
export const ICON_XXS = 14  // tiny inline icons
export const ICON_XS = 18  // tiny inline icons
export const ICON_SM = 20  // small toolbar icons
export const ICON_MD = 22  // standard toolbar icon
export const ICON_LG = 24  // medium panel icons
export const ICON_XL = 26  // large icons
export const ICON_XXL = 36  // large icons
export const ICON_NAV = 28  // navigation sidebar icons
export const TEXT_BUTTON = '#2A2A2A'

declare module '@mui/material/styles' {
    interface Palette {
        tertiary: Palette['primary']
        quaternary: Palette['primary']
    }
    interface PaletteOptions {
        tertiary?: PaletteOptions['primary']
        quaternary?: PaletteOptions['primary']
    }
}

// MUI theme - wired into the brand palette so primary buttons / focus
// rings pick up the gold automatically.
export const theme = createTheme({
    palette: {
        primary: { main: COLOR_PRIMARY },
    },
})
